module.exports = __webpack_public_path__ + "img/122.998aa2c8.jpg";